<footer class="bg-black small text-center text-white-50" [dir]="languageService.getDir()">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 contacts-column">
        <div class="footer-logo">
          <img alt="Logo" width="146" src="assets/img/logo-1.png"/>
        </div>
        <div>
          <ul class="contacts-list-items">
            <li class="contacts-list-item">
              <a href="{{ 'FOOTER.CONTACTS.PHONE_LINK' | translate }}">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.076 512.076" style="enable-background:new 0 0 512.076 512.076;" xml:space="preserve">
                    <g transform="translate(-1 -1)">
                      <g>
                        <g>
                          <path d="M499.639,396.039l-103.646-69.12c-13.153-8.701-30.784-5.838-40.508,6.579l-30.191,38.818    c-3.88,5.116-10.933,6.6-16.546,3.482l-5.743-3.166c-19.038-10.377-42.726-23.296-90.453-71.04s-60.672-71.45-71.049-90.453    l-3.149-5.743c-3.161-5.612-1.705-12.695,3.413-16.606l38.792-30.182c12.412-9.725,15.279-27.351,6.588-40.508l-69.12-103.646    C109.12,1.056,91.25-2.966,77.461,5.323L34.12,31.358C20.502,39.364,10.511,52.33,6.242,67.539    c-15.607,56.866-3.866,155.008,140.706,299.597c115.004,114.995,200.619,145.92,259.465,145.92    c13.543,0.058,27.033-1.704,40.107-5.239c15.212-4.264,28.18-14.256,36.181-27.878l26.061-43.315    C517.063,422.832,513.043,404.951,499.639,396.039z M494.058,427.868l-26.001,43.341c-5.745,9.832-15.072,17.061-26.027,20.173    c-52.497,14.413-144.213,2.475-283.008-136.32S8.29,124.559,22.703,72.054c3.116-10.968,10.354-20.307,20.198-26.061    l43.341-26.001c5.983-3.6,13.739-1.855,17.604,3.959l37.547,56.371l31.514,47.266c3.774,5.707,2.534,13.356-2.85,17.579    l-38.801,30.182c-11.808,9.029-15.18,25.366-7.91,38.332l3.081,5.598c10.906,20.002,24.465,44.885,73.967,94.379    c49.502,49.493,74.377,63.053,94.37,73.958l5.606,3.089c12.965,7.269,29.303,3.898,38.332-7.91l30.182-38.801    c4.224-5.381,11.87-6.62,17.579-2.85l103.637,69.12C495.918,414.126,497.663,421.886,494.058,427.868z"></path>
                          <path d="M291.161,86.39c80.081,0.089,144.977,64.986,145.067,145.067c0,4.713,3.82,8.533,8.533,8.533s8.533-3.82,8.533-8.533    c-0.099-89.503-72.63-162.035-162.133-162.133c-4.713,0-8.533,3.82-8.533,8.533S286.448,86.39,291.161,86.39z"></path>
                          <path d="M291.161,137.59c51.816,0.061,93.806,42.051,93.867,93.867c0,4.713,3.821,8.533,8.533,8.533    c4.713,0,8.533-3.82,8.533-8.533c-0.071-61.238-49.696-110.863-110.933-110.933c-4.713,0-8.533,3.82-8.533,8.533    S286.448,137.59,291.161,137.59z"></path>
                          <path d="M291.161,188.79c23.552,0.028,42.638,19.114,42.667,42.667c0,4.713,3.821,8.533,8.533,8.533s8.533-3.82,8.533-8.533    c-0.038-32.974-26.759-59.696-59.733-59.733c-4.713,0-8.533,3.82-8.533,8.533S286.448,188.79,291.161,188.79z"></path>
                        </g>
                      </g>
                    </g>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
                </span>
                <span dir="ltr">{{ 'FOOTER.CONTACTS.PHONE' | translate }}</span>
              </a>
            </li>
            <li class="contacts-list-item">
              <a href="mailto:office@quickhub.co.il">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <g>
                      <g>
                        <path d="M467,76H45C20.137,76,0,96.262,0,121v270c0,24.885,20.285,45,45,45h422c24.655,0,45-20.03,45-45V121   C512,96.306,491.943,76,467,76z M460.698,106c-9.194,9.145-167.415,166.533-172.878,171.967c-8.5,8.5-19.8,13.18-31.82,13.18   s-23.32-4.681-31.848-13.208C220.478,274.284,64.003,118.634,51.302,106H460.698z M30,384.894V127.125L159.638,256.08L30,384.894z    M51.321,406l129.587-128.763l22.059,21.943c14.166,14.166,33,21.967,53.033,21.967c20.033,0,38.867-7.801,53.005-21.939   l22.087-21.971L460.679,406H51.321z M482,384.894L352.362,256.08L482,127.125V384.894z"></path>
                      </g>
                    </g>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
                </span>
                <span>office@quickhub.co.il</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-3 branch-column">
        <h2>{{ 'FOOTER.BRANCH.TITLE' | translate }}</h2>
        <ul class="branch-list-items"
            [class.text-right]="languageService.isCurrent('Hebrew')"
            [class.text-left]="languageService.isCurrent('English')">
          <li class="branch-list-item">
            <span class="branch-list-text">{{ 'FOOTER.BRANCH.OFFICE' | translate }}</span>
          </li>
          <li class="branch-list-item">
            <span class="branch-list-text">{{ 'FOOTER.BRANCH.COFFEE' | translate }}</span>
          </li>
          <li class="branch-list-item">
            <span class="branch-list-text">{{ 'FOOTER.BRANCH.EVENTS' | translate }}</span>
          </li>
        </ul>
      </div>
      <div class="col-lg-5 contact-us-column">
<!--        <div class="contact-us-top">-->
<!--          <div class="contact-us-circle">-->
<!--            <img loading="lazy" width="94" height="94"-->
<!--                 src="https://quickhub.co.il/wp-content/uploads/2022/01/Ellipse-1-copy-2.png"-->
<!--                 class="attachment-large size-large wp-image-362" alt="">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="contact-us-container text-left">-->
<!--          <p>Are you ready to <br>-->
<!--            experience-->
<!--            <span style="color: #e01b4e;">Quick?</span>-->
<!--          </p>-->
<!--          <h2>Please leave your details, and we will be delighted to get in touch with you.</h2>-->
<!--          <form>-->
<!--            <div class="form-row">-->
<!--              <div class="col-md-6 mb-3">-->
<!--                <input type="text" class="form-control contact-us-form-control"-->
<!--                       formControlName="name" id="name" placeholder="Name">-->
<!--              </div>-->
<!--              <div class="col-md-6 mb-3">-->
<!--                <input type="text" class="form-control contact-us-form-control"-->
<!--                       formControlName="phone" id="phone" placeholder="Phone">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="form-row">-->
<!--              <div class="col-md-12 mb-3">-->
<!--                <textarea class="form-control contact-us-form-control" rows="3"-->
<!--                          formControlName="message" id="message" placeholder="Hello, I came to you through the website. I would love for you to get back to me for a personalized offer."></textarea>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="form-row">-->
<!--              <div class="col-md-6 mb-3">-->
<!--                <input type="email" class="form-control contact-us-form-control"-->
<!--                       formControlName="email" id="email" placeholder="Email">-->
<!--              </div>-->
<!--              <div class="col-md-6 mb-3">-->
<!--                <button type="submit" class="btn btn-danger send-button" [dir]="languageService.getDir()">-->
<!--                  {{'CONTACTS_SECTION.FORM.SEND_BUTTON' | translate}}-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </form>-->
<!--        </div>-->
      </div>
    </div>
  </div>
  <div class="row footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-sm-3">
          <a class="nav-link" href="https://ndesign.co.il" target="_blank">עיצוב ובנייה NDESIGN</a>
        </div>
        <div class="col-sm-3">
          <a class="nav-link"
             [dir]="languageService.getDir()"
             href="/assets/files/Terms of use Quick Hub.pdf" target="_blank">Terms of use</a>
        </div>
        <div class="col-sm-3">
          <a class="nav-link"
             [dir]="languageService.getDir()"
             href="assets/files/Quick Hub Privacy Policy.pdf" target="_blank">Privacy Policy</a>
        </div>
        <div class="col-sm-3">
          <a class="nav-link" href="#">כל הזכויות שמורות ל-Quick</a>
        </div>
      </div>
    </div>
  </div>
</footer>
